import { z } from "zod/v4"

export const RelationStrSchema = z.object({
  id: z.string().default(""),
  name: z.string().default(""),
  order: z.number().default(0),
})

export type RelationStr = z.infer<typeof RelationStrSchema>
export const RelationStrEmpty = RelationStrSchema.parse({})
